import {
  Card,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow as TableRowMUI,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import { convertIsoToBrazilianDateTime } from "@/helpers/date-helpers";
import { IOrderInput, IOrderStatus } from "@/interfaces/order.interfaces";
import { HistoryDataTabMessages } from "@/messages/order-form-page/order-history-tab.messages";
import { OrderStatus } from "@/types/order.types";

type Props = {
  messages: HistoryDataTabMessages;
  order: IOrderInput | null;
};

function HistoryDataTab({ messages, order }: Props) {
  const statusHistory: IOrderStatus[] = order && Array.isArray(order.status) ? order.status : [];

  const getStatusDescription = (code: OrderStatus) => {
    switch (code) {
      case OrderStatus.Confirmed:
        return messages.statusConfirmed;
      case OrderStatus.Paid:
        return messages.statusPaid;
      case OrderStatus.Handling:
        return messages.statusHandling;
      case OrderStatus.Invoiced:
        return messages.statusInvoiced;
      case OrderStatus.Shipped:
        return messages.statusShipped;
      case OrderStatus.Delivered:
        return messages.statusDelivered;
      case OrderStatus.Cancelled:
        return messages.statusCancelled;
      case OrderStatus.Waiting:
        return messages.statusWaiting;
      case OrderStatus.Error:
        return messages.statusError;
      case OrderStatus.CancellationRequest:
        return messages.statusCancellationRequest;
      default:
        return "";
    }
  };

  const columns = [messages.dateTimeLabel, messages.statusDescriptionLabel];

  return (
    <MDBox mt={2}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <MDBox height="100%">
            <Card>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDTypography variant="h5" fontWeight="bold">
                    {messages.historyTitle}
                  </MDTypography>
                </MDBox>

                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    <TableContainer>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRowMUI>
                            {columns.map((label, index) => (
                              <TableCell key={`${index}-${label}`}>{label}</TableCell>
                            ))}
                          </TableRowMUI>
                        </TableHead>

                        <TableBody>
                          {statusHistory && statusHistory.length <= 0 ? (
                            <TableRowMUI>
                              <TableCell colSpan={columns.length} align="center">
                                <MDTypography variant="h6" color="text" fontWeight="regular">
                                  {messages.noHistoryMessage}
                                </MDTypography>
                              </TableCell>
                            </TableRowMUI>
                          ) : (
                            statusHistory.map((statusItem, index) => (
                              <TableRow key={index} index={index}>
                                <TableCell>
                                  {convertIsoToBrazilianDateTime(statusItem.rowDate)}
                                </TableCell>
                                <TableCell>
                                  {getStatusDescription(statusItem.statusDetail.code)}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default HistoryDataTab;
